import React from "react";
import {TFunction} from "i18next";

import ShowMoreMenu from "../../../../../../../../../../../../../common/showMoreMenu";

type Params = {
  onEdit(id: number): void
  onRemove(id: number): void
  products?: ProductListItem[]
  readOnly?: boolean
  t: TFunction
}

const getProductListRows = ({ products, onEdit, onRemove, readOnly = false, t }: Params) =>
  products?.map((productListItem: ProductListItem, index: number) => ({
    ...productListItem,
    id: index + 1,
    settings: <ShowMoreMenu menuItems={[
      {
        title: t('actions__text__edit'),
        onClick: () => onEdit(productListItem.id)
      },
      {
        title: t('actions__text__delete'),
        onClick: () => onRemove(productListItem.id)
      },
    ]} />,
  }));

export default getProductListRows
